import {
  type FetchDeviceListParams,
  fetchDevices,
  fetchSingleDevice
} from 'Services/ServiceProviderManagement/Features/Device/deviceSlice'
import useTypedSelector, { useAppDispatch } from 'Store'
import { ROWS_PER_PAGE_DEFAULT, SORT_ORDER_ASC } from 'Util/constants'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const SELECTED_DEVICE_PARAMETER_KEY = 'selectedDevice'

function useDevicesWithParams() {
  const dispatch = useAppDispatch()
  const { devices, loading, total_results, next_page, previous_page } = useTypedSelector(
    state => state.device
  )
  const [searchParams, setSearchParams] = useSearchParams()

  const [params, setParams] = useState<FetchDeviceListParams>({
    name: searchParams.get('name') ?? undefined,
    search_text: searchParams.get('search_text') ?? undefined,
    sort_by: searchParams.get('sort_by') ?? 'deviceId',
    sort_order: searchParams.get('sort_order') ?? SORT_ORDER_ASC,
    start_index: searchParams.get('start_index') ?? undefined,
    count: ROWS_PER_PAGE_DEFAULT
  })

  const selectedDeviceQueryParam = searchParams.get(SELECTED_DEVICE_PARAMETER_KEY) ?? undefined
  const [selectedDeviceId, setSelectedDeviceId] = useState(selectedDeviceQueryParam)

  const setQueryParams = () => {
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value.toString())
      } else {
        searchParams.delete(key)
      }
    })

    selectedDeviceId && searchParams.set(SELECTED_DEVICE_PARAMETER_KEY, selectedDeviceId)

    setSearchParams(searchParams)
  }

  useEffect(() => {
    dispatch(fetchDevices(params))
    setQueryParams()
  }, [params])

  useEffect(() => {
    if (selectedDeviceId) {
      dispatch(fetchSingleDevice({ id: selectedDeviceId }))
      setQueryParams()
    } else {
      searchParams.delete(SELECTED_DEVICE_PARAMETER_KEY)
      setSearchParams(searchParams)
    }
  }, [selectedDeviceId])

  return {
    devices,
    loading,
    params,
    setParams,
    total_results,
    next_page,
    previous_page,
    selectedDeviceId,
    setSelectedDeviceId
  }
}

export default useDevicesWithParams
